import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Loader } from "@egovernments/digit-ui-react-components";
import MapSubmissionSummarys from "./MapSubmissionSummary";



function SearchSummary({ id, ref, handleDeclarationChange, declarationChecked, showDeclaration, logoData }) {
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const { data = {}, isLoading, refetch } = Digit.Hooks.obps.useBPADetailsPage(stateId, { applicationNo: id, isEmployee }, { formType: "MAP_SUB" });
   useEffect(() => {
      if (id) {
        refetch();
      }
    }, [id, refetch]);
  if (isLoading) {
    return <Loader />
  } 
  return (
    <React.Fragment>
      {!isLoading && data && (
        <MapSubmissionSummarys
          formData={data?.BPA?.[0]}
          ref={ref}
          handleDeclarationChange={handleDeclarationChange}
          declarationChecked={declarationChecked}
          showDeclaration={showDeclaration}
          logoData={logoData}
        />
      )}
    </React.Fragment>
  );
}

export default SearchSummary;
